import React from 'react'

import 'less/loading.less'

const Loader = () => (
  <div className="loading-dots" />
)

export default Loader
